namespace RioERP.Enquiry {
    export interface EnquiryProductsForm {
        EnquiryId: Serenity.LookupEditor;
        ProductId: Serenity.LookupEditor;
        IsActive: Serenity.BooleanEditor;
        ProductProductName: Serenity.StringEditor;
    }

    export class EnquiryProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Enquiry.EnquiryProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EnquiryProductsForm.init)  {
                EnquiryProductsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.StringEditor;

                Q.initFormType(EnquiryProductsForm, [
                    'EnquiryId', w0,
                    'ProductId', w0,
                    'IsActive', w1,
                    'ProductProductName', w2
                ]);
            }
        }
    }
}
